import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';


@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(private toastr: ToastrService) { }

  checkToastContainer(){

    if (!document.getElementById('toast-container')) {
      const toastContainer = document.createElement('div');

      toastContainer.setAttribute('aria-live', 'polite');
      toastContainer.classList.add('overlay-container');

      // Corrected line (no extra quote at the end)
      toastContainer.innerHTML = `<div id="toast-container" class="toast-top-right toast-container"></div>`;

      document.body.appendChild(toastContainer);
    }
  }

  showSuccess(message: string, title: string) {
    this.checkToastContainer();

    this.toastr.success(message, title, {
      positionClass: 'toast-top-right',
      toastClass: 'ngx-toastr custom-toast-success',
      timeOut: 1500
    });
  }

  showError(message: string, title: string) {
    this.checkToastContainer();

    this.toastr.error(message, title, {
      positionClass: 'toast-top-right',
      toastClass: 'ngx-toastr custom-toast-error',
      timeOut:5500
    });
  }

  showInfo(message: string, title: string) {
    this.toastr.info(message, title, {
      positionClass: 'toast-top-right',
      toastClass: 'ngx-toastr custom-toast-info',
      timeOut: 5500
    });
  }

  showWarning(message: string, title: string) {
    this.toastr.warning(message, title, {
      positionClass: 'toast-top-right',
      toastClass: 'ngx-toastr custom-toast-warning',
      timeOut:5500
    });
  }
}
